import { Component } from "@angular/core";
//export interface NJDocDataI {
//     docDataHdrId: number;
//     docDefTemplateID: number;
//     docDefDataRowID: number;
//     docDefDataRowParID: number;
//     dataValue: string;
//}
export class NJDocData {
    public docDataHdrId: number;
    public docDefTemplateID: number;
    public docDefDataRowID: number;
    public docDefDataRowParID: number;
    public dataValue: string;
}
export class NJDocDefTemplate {
    public dictCustomParameters: any;
    public lookupTypeId: number;
    public tOrder: number;
    public customParameters: string;
    public validationType: string;
    public tableColumnName: string;
    public tableName: string;
    public indent: number;
    public tLabelFontWeight: string;
    public tLabel: string;
    public tType: string;
    public docDefSecId: number;
    public docDefTemplateParID: number;
    public docDefTypeSubId: number;
    public docDefTemplateID: number;
    public tLabelPosition: number;
    public templateCode: string;
    public isValid: boolean = true;
}
export class NJReadDocDefTemplateLookup {
    public lookupId: number;
    public lookupType: string;
    public longDesc: string;
    public shortDesc: string;
    public active: string;
    public sortOrder: number;
    public longDesc2: string;
    public lookupTypeId: number;
    public lookupTypeId_Sub: number;
    public lookupId_Par: number;
    public shortDescDisplay: string;
    public isValid: boolean = true;
}
//input
export class DOData {
    public customParameters: any = {};
    public njDocData: NJDocData = new NJDocData();
    public njDocDefTemplate: NJDocDefTemplate = new NJDocDefTemplate();
    public lstDocData: Array<NJDocData> = new Array<NJDocData>();
    public lstChildDocDefTemplate: Array<NJDocDefTemplate> = new Array<NJDocDefTemplate>();
    public lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup> = new Array<NJReadDocDefTemplateLookup>();
    public isValid: boolean = true;
    public isEnabled: boolean = true;
    public njDocDataSave: Array<NJDocDataSaveProcOutput> = new Array<NJDocDataSaveProcOutput>();
    public PreviousDropdownValue: string = '';
    public PreviousCommentValue: string = '';
    public PreviousLabelValue: string = '';
}
//output

export class AutoCompleteTextBoxEntry {
    public display: string;
    public returnArg: string;
}

export class DocdefDataVM {
    public loaderKey: string;
    public action: string = "";
    public docdata: Array<NJDocData> = new Array<NJDocData>();
    public UserName: string;
}
export class InputParamsVM {
    public loaderKey: string;
    public docdata: DOData = new DOData();
}
export class componentVM {
    public thisComponent: any;
    public tag: string;
}
export class TabVM {
    public loaderKey: string = "";
    public docdata: Array<Array<DOData>> = new Array<Array<DOData>>();
}
export class modalParams {
    public tabTemplateCode: string;
    public loaderKey: string;
    public strDocDefTypeSubCode: string;
    public gridTemplateCode: string;
    public lstModalParams: Array<ModalParamsElem> = new Array<ModalParamsElem>();
}
export class ModalParamsElem {
    public value: string;
    public param: string;
}
export class childSearchReq {
    
    // diaglog specific parameters
    public tab: string = "";
    public gridTemplateCode: string = "";
    public title: string = "";
    public content: string = "";
    public returnData: boolean = false;
    // core search parameters
    public memberID: string = "";
    public firstName: string = "";
    public lastName: string = "";
    public DOB: string = "";
    public SSN: string = "";
    public Age: string = "";
    public ParentName: string = "";
    public Gender: string = "";
}

export class planApprovalParams {
    // core parameters
    public tab: string = "";
    public gridTemplateCode: string = "";
    public title: string = "";
    public content: string = "";
}


export class clsAuthorizations {//35569
    public authorizationId: number;
    public recordFlag: string;
    public txtProvider: string;
    public txtServiceCode: string;
    public txtFrequency: string;
    public dtpStartDate: string;
    public dtpEndDate: string;
    public reqUnits: string;
    public apprUnits: string;
    public deniedUnits: string;
    public decision: string;
    public memberId: number;
    public authID: string;
    public submitted_Date: string;
    public authStatus: string;
    public perUnitCost: string = '0';
    public createDate: string;
    public createUser: string;
    public CSAAuthStatus: string;
    public CSADeniedReason: string;
    public CSADeniedReasonStatus: string;
    public CSAServiceID: string;
    public treatmentID: number;
    public authReturnCode: string;;
    public reason: string;
    public reasonOther: string;
}
export class clsAuthorization {
    public authorizationId: number;
    public recordFlag : string;
    public txtProvider: string;
    public txtServiceCode: string;
    public txtFrequency: string;
    public dtpStartDate: string;
    public dtpEndDate: string;
    public reqUnits: string;
    public apprUnits: string;
    public deniedUnits: string;
    public decision: string;
    public memberId: number;
    public authID: string;
    public submitted_Date: string;
    public authStatus: string;
    public  perUnitCost:number = 0;
    public createDate: string;
    public createUser: string;
    public CSAAuthStatus: string;
    public CSADeniedReason: string;
    public CSADeniedReasonStatus: string;
    public CSAServiceID: string;
    public treatmentID: number;
    public authReturnCode: string;;
    public reason: string;
    public reasonOther: string;
}
export class GoogleMapType {
    public tab: string = "";
    public gridTemplateCode: string = "";
    public providerType: string = "";
    public program: string = "";
    public providerSpecialty: string = "";
    public siteCIMIDS: string = "";
    public siteCIMIDRequired: boolean = false;
    public reOpenPopup: boolean = false;
    public title: string = "Provider GEO MAP";
    public content: string = "";
    public MemberID: string = "";
}
export class clsMemberMessage {
    public MessageID: any = 0;
    public CreatedDate: string = "";
    public RecordFlag: string = "";
    public FromUserID: string = "";
    public ToUSerID: string = "";
    public MsgSubject: string = "";
    public MsgBody: string = "";
    public Priority: string = "";
    public EMailType: string = "";
    public IsRead: string = "";
    public Action: string = "";
    public SourceType: string = "";
}
export class NJDocDataSaveProcOutput {
    public parmKey: string = "";
    public columnName: string = "";
    public valueBefore: string = "";
    public valueAfter: string = "";
}
